import type { MultiPolygon as GeoJSONMultiPolygon, Polygon as GeoJSONPolygon } from 'geojson';

// We cannot have these types in the worker, and having them in the api will create a cyclic dependency
// because the worker needs them too, so we extracted them here

export const ClassicWorkerOperations = {
  MergeGeometries: 'mergeGeometries',
  ValidateGeometries: 'validateGeometries'
};

export class ClassicMergeParams {

  op = ClassicWorkerOperations.MergeGeometries;
  currentGeometries: (GeoJSONPolygon | GeoJSONMultiPolygon)[];
  newGeometry: GeoJSONPolygon | GeoJSONMultiPolygon;

  constructor (currentGeometries: (GeoJSONPolygon | GeoJSONMultiPolygon)[], newGeometry: GeoJSONPolygon | GeoJSONMultiPolygon) {
    this.currentGeometries = currentGeometries;
    this.newGeometry = newGeometry;
  }

}

export class ClassicValidationParams {

  op = ClassicWorkerOperations.ValidateGeometries;
  geometriesBeingModified: (GeoJSONPolygon | GeoJSONMultiPolygon)[];
  allOtherGeometries: (GeoJSONPolygon | GeoJSONMultiPolygon)[];

  constructor (geometriesBeingModified: (GeoJSONPolygon | GeoJSONMultiPolygon)[], allOtherGeometries: (GeoJSONPolygon | GeoJSONMultiPolygon)[]) {
    this.geometriesBeingModified = geometriesBeingModified;
    this.allOtherGeometries = allOtherGeometries;
  }

}
